import React from 'react';
// import ReactDOM from 'react-dom';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import TagManager from 'react-gtm-module';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from "@sentry/tracing";
import Routes from './components/routes';
import Store from './components/store';
import ErrorHandle from './components/errorhandle';
import ThemeHandle from './components/themehandle';
import LoadAssets from './components/loadassets';
import './components/themes.scss';
import './components/app.scss';
import NetworkService from './services/NetworkService';
import StatusLoop from './components/statusloop';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: "https://180c3a30c2ab4eb3befbaddb7af0b14c@o510840.ingest.sentry.io/5898585",
    environment: 'production',
    integrations: [
      new BrowserTracing({
        tracingOrigins: ["localhost", process.env.REACT_APP_HOSTNAME, /^\//],
      }),
    ],
    tracesSampleRate: 1,
  });
}

NetworkService.setupInterceptors(Store);

const tagManagerArgs = {
  gtmId: 'GTM-5GCT86L',
  events: {
  },
};
TagManager.initialize(tagManagerArgs);

// const store = configureStore()

hydrate(
  <Provider store={Store}>
    <BrowserRouter>
      <Sentry.ErrorBoundary>
        <ErrorHandle>
          <LoadAssets>
            <StatusLoop>
              <ThemeHandle>
                {renderRoutes(Routes)}
              </ThemeHandle>
            </StatusLoop>
          </LoadAssets>
        </ErrorHandle>
      </Sentry.ErrorBoundary>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);
